export const PLATFORM_CHART_COLOURS = [
  '#6366F1',
  '#EC4899',
  '#0891B2',
  '#D97706',
  '#8B5CF6',
  '#F59E0B',
  '#059669',
  '#EF4444',
  '#2563EB',
] as const;

export function formatCompactNumber(value: number, options?: { currency?: boolean; decimals?: number }): string {
  if (options?.currency) {
    return value.toLocaleString(undefined, {
      style: 'currency',
      currency: 'USD',
      maximumFractionDigits: options.decimals ?? 0,
    });
  }
  if (Math.abs(value) >= 1_000_000) {
    return `${(value / 1_000_000).toFixed(1)}M`;
  }
  if (Math.abs(value) >= 1_000) {
    return `${(value / 1_000).toFixed(1)}K`;
  }
  return value.toLocaleString(undefined, {
    maximumFractionDigits: options?.decimals ?? 0,
  });
}

export function formatRatePercent(value: number, digits = 2): string {
  if (!Number.isFinite(value)) return '0%';
  return `${value.toFixed(digits)}%`;
}

export function formatCurrency(value: number, digits = 2): string {
  return value.toLocaleString(undefined, {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  });
}

export function formatPercentChangeLabel(change: number): string {
  if (!Number.isFinite(change)) return '0%';
  return `${Math.abs(change).toFixed(1)}%`;
}

export function getChangeDirection(change: number): 'up' | 'down' | 'neutral' {
  if (change > 0) return 'up';
  if (change < 0) return 'down';
  return 'neutral';
}

export function safePercentChange(current: number, past: number): number {
  if (!Number.isFinite(current) || !Number.isFinite(past) || past === 0) {
    return current === 0 ? 0 : 100;
  }
  return ((current - past) / past) * 100;
}

export function formatPlatformDisplayName(platform: string): string {
  return platform.replace(/_/g, ' ');
}

export function deriveCtr(clicks: number, impressions: number): number {
  if (!impressions) return 0;
  return (clicks / impressions) * 100;
}

export function deriveCpc(spend: number, clicks: number): number {
  if (!clicks) return 0;
  return spend / clicks;
}

export function deriveCpm(spend: number, impressions: number): number {
  if (!impressions) return 0;
  return (spend / impressions) * 1000;
}

export function deriveCpa(spend: number, conversions: number): number {
  if (!conversions) return 0;
  return spend / conversions;
}
